export default "__VITE_ASSET__QXD$ty9v__"